import { call, put, takeLatest } from 'redux-saga/effects';

import * as welcomeMessageActions from './welcomeMessageActions.js';
import { updateWelcomeMessageApiCall } from './welcomeMessageAPI.js';

function* updateWelcomeMessageSaga({ payload }) {
  try {
    const { data } = yield call(updateWelcomeMessageApiCall, payload);
    yield put(welcomeMessageActions.welcomeMessageUpdateStore(data));
  } catch (error) {
    yield put(welcomeMessageActions.welcomeMessageUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* welcomeMessageWatcher() {
  yield takeLatest(welcomeMessageActions.welcomeMessageUpdateRequest.type, updateWelcomeMessageSaga);
}
